module.exports = __webpack_public_path__ + "static/media/logo-chef.ca69eddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-chef.png
// module id = 402
// module chunks = 0